const state = {
}

const getters = {
}

const mutations = {
}

const actions = {
  updateUserBry ({ state, commit, rootState }, params) {
    return rootState.axios.get('/cc/v1frontend/ccms-sync/update-user-bry', { params })
  },
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
